/* eslint-disable jsdoc/check-param-names */
import { Brick, registerBrick, BrickContext } from 'olympe';
import { getLogger } from '@olympeio/core';

export default class BuildResponsibilityRequestFilter extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} rule
     * @param {string[]} companyCodes
     * @param {string[]} userIds
     * @param {string[]} positions
     * @param {string[]} respIds
     * @param {string[]} blockingReason
     * @param {string[]} plants
     * @param {string[]} materialGroups
     * @param {string[]} purchasingGroups
     * @param {function(string): void} setPath
     */
    // prettier-ignore
    update($, [rule, companyCodes, userIds, positionsIds, respIds, blockingReason, plants, materialTypes, materialGroups, purchasingGroups, storageLocations, responsibilities], [setPath]) {
        const logger = getLogger('BuildResponsibilityRequestPath');

        logger.debug('Building responsibility request path with');
        logger.debug('rule', rule);
        logger.debug('companyCodes', companyCodes);
        logger.debug('userIds', userIds);
        logger.debug('positionsIds', positionsIds);
        logger.debug('respIds', respIds);
        logger.debug('blockingReason', blockingReason);
        logger.debug('plants', plants);
        logger.debug('materialTypes', materialTypes);
        logger.debug('materialGroups', materialGroups);
        logger.debug('purchasingGroups', purchasingGroups);
        logger.debug('storageLocations', storageLocations);
        
        const paths = [];

        const addPath = (key, values) => {
            paths.push(
                `(${values.map(value => `${key} eq '${value}'`).join(' or ')})`
            );
        };

        if (rule) {
            addPath('Rule', [rule]);
        }

        if (companyCodes?.length) {
            addPath('CompCode', companyCodes);
        }

        if (userIds?.length) {
            addPath('AgentId', userIds);
            addPath('AgentType', ['US']);
        }

        if (positionsIds?.length) {
            addPath('AgentId', positionsIds);
            addPath('AgentType', ['S'])
        }

        if (respIds?.length) {
            addPath('RespNo', respIds);
        }

        if (blockingReason?.length) {
            addPath('BlockingReason', blockingReason);
        }

        if (plants?.length) {
            addPath('Plant', plants);
        }

        if (materialTypes?.length) {
            addPath('MaterialType', materialTypes);
        }

        if (materialGroups?.length) {
            addPath('MaterialGroup', materialGroups);
        }

        if (purchasingGroups?.length) {
            addPath('PurchGroup', purchasingGroups);
        }

        if (storageLocations?.length) {
            addPath('StorageLoc', storageLocations);
        }

        if (responsibilities?.length) {
            addPath('RespNo', responsibilities);
        }

        const finalPath = paths.join(' and ');
        logger.debug('finalPath', finalPath);
        setPath(finalPath);
    }
}

registerBrick('018af9fd4535904c8681', BuildResponsibilityRequestFilter);
